export enum AiChatProTipType {
  ATTACHMENT_ADDED = 'attachment_added',
  LOW_RES_ATTACHMENT = 'low_res_attachment',
  REFER_OLDER_VERSION = 'refer_older_version',
  EXACT_TEXT_PROMPTING = 'exact_text_prompting',
  SPELLING_ISSUES = 'spelling_issues',
  LONG_CHAT_CONTEXT = 'long_chat_context',
  VAGUE_PROMPT = 'vague_prompt',
  TOO_LONG_TEXT = 'too_long_text',
  EDITING_TIPS = 'editing_tips',
  CHANGE_STYLE_ANNOUNCEMENT = 'change_style_announcement',
}
